import { v4 as uuid } from 'uuid'
import { useLiveQuery } from 'dexie-react-hooks'
import { searchConditionDB } from '@/dexieDatabases/SearchConditionDatabase'

const useSearchCondition = () => {
  const conditionList = useLiveQuery(() => searchConditionDB.searchConditions.toArray(), []) ?? []

  const getParams = () => {
    return (
      conditionList
        ?.filter((s) => s.enabled)
        .map((s) => `${s.key}=${s.value}`)
        .join('&') ?? ''
    )
  }

  const add = async (key: string, value: string) => {
    await searchConditionDB.searchConditions.add({ uuid: uuid(), key: key, value: value, enabled: true })
  }

  const applyChange = async (uuid: string, key: string, value: string) => {
    const target = await searchConditionDB.searchConditions.where({ uuid: uuid }).first()
    if (target?.id !== undefined) {
      await searchConditionDB.searchConditions.update(target.id, { key, value })
    }
  }

  const setEnabled = async (uuid: string, b: boolean) => {
    const target = await searchConditionDB.searchConditions.where({ uuid: uuid }).first()
    if (target?.id !== undefined) {
      await searchConditionDB.searchConditions.update(target.id, { enabled: b })
    }
  }

  const remove = async (uuid: string) => {
    const target = await searchConditionDB.searchConditions.where({ uuid: uuid }).first()
    if (target?.id !== undefined) {
      await searchConditionDB.searchConditions.delete(target.id)
    }
  }

  const clear = async () => {
    await searchConditionDB.delete()
    await searchConditionDB.open()
  }

  return { conditionList, getParams, add, applyChange, setEnabled, remove, clear }
}

export { useSearchCondition }
